import { render, staticRenderFns } from "./UnpaidAbsentDay.vue?vue&type=template&id=59d79d30&scoped=true"
import script from "./UnpaidAbsentDay.vue?vue&type=script&lang=ts"
export * from "./UnpaidAbsentDay.vue?vue&type=script&lang=ts"
import style0 from "./UnpaidAbsentDay.vue?vue&type=style&index=0&id=59d79d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d79d30",
  null
  
)

export default component.exports